import { fundRankingConstants } from '../_constants/fund-ranking.constants';

// Set Page
export const updatePage = (page) => ({
	type: fundRankingConstants.SET_CURRENT_FUND_RANKING_PAGE,
  payload: page
});

export const setTotalPage = (page) => ({
	type: fundRankingConstants.SET_TOTAL_RANKING_PAGE,
  payload: page
});

// Get Rank Fund
export const setFundIdRank = (fundId) => ({
  type: fundRankingConstants.SET_FUND_ID_RANK,
  payload: fundId
});

export const fetchFundRankStart = (data) => ({
  type: fundRankingConstants.FETCH_FUND_RANK_START,
  payload: data
});

export const fetchFundRankSuccess = (data) => ({
  type: fundRankingConstants.FETCH_FUND_RANK_SUCCESS,
  payload: data
});

export const fetchFundRankFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_FUND_RANK_FAILURE,
  payload: errorMessage
});

// Get Search Filters
export const fetchRankingSearchFiltersStart = () => ({
	type: fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_START,
});

export const fetchRankingSearchFiltersSuccess = (data) => ({
	type: fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_SUCCESS,
  payload: data
});

export const fetchRankingSearchFiltersFailure = (errorMessage) => ({
	type: fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_FAILURE,
  payload: errorMessage
});

// Get Search fund
export const fetchRankingsStart = (body) => ({
  type: fundRankingConstants.FETCH_RANKINGS_START,
  payload: body
});

export const fetchRankingsSuccess = (rankings) => ({
  type: fundRankingConstants.FETCH_RANKINGS_SUCCESS,
  payload: rankings
});

export const fetchRankingsFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_RANKINGS_FAILURE,
  payload: errorMessage
});

// Highlight Funds
export const setHighlightFundPeriod = (period) => ({
  type: fundRankingConstants.SET_HIGHLIGHT_FUND_PERIOD,
  payload: period
});

export const fetchHighlightFundStart = (fundCodes) => ({
  type: fundRankingConstants.FETCH_HIGHLIGHT_FUND_START,
  payload: fundCodes
});

export const fetchHighlightFundSuccess = (nav) => ({
  type: fundRankingConstants.FETCH_HIGHLIGHT_FUND_SUCCESS,
  payload: nav
});

export const fetchHighlightFundFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_HIGHLIGHT_FUND_FAILURE,
  payload: errorMessage
});

// Nav Ranking
export const updateNavDateChart = (dateType) => ({
	type: fundRankingConstants.UPDATE_NAV_DATE_FUND_RANKING,
	payload: dateType
});

export const setNavTypeRanking = (navType) => ({
  type: fundRankingConstants.SET_NAV_TYPE_RANKING,
  payload: navType
})

export const fetchNavRankingsStart = (fundCodes) => ({
  type: fundRankingConstants.FETCH_NAV_RANKINGS_START,
  payload: fundCodes
});

export const fetchNavRankingsSuccess = (nav) => ({
  type: fundRankingConstants.FETCH_NAV_RANKINGS_SUCCESS,
  payload: nav
});

export const fetchNavRankingsFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_NAV_RANKINGS_FAILURE,
  payload: errorMessage
});

// Get Default Categories
export const fetchCategoriesStart = () => ({
  type: fundRankingConstants.FETCH_CATEGORIES_START
});

export const fetchCategoriesSuccess = (categories) => ({
  type: fundRankingConstants.FETCH_CATEGORIES_SUCCESS,
  payload: categories
});

export const fetchCategoriesFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_CATEGORIES_FAILURE,
  payload: errorMessage
});

export const updateCategories = (categories) => ({
  type: fundRankingConstants.UPDATE_CATEGORIES,
  payload: categories
});

export const appendCategory = (category) => ({
  type: fundRankingConstants.APPEND_CATEGORY,
  payload: category
});

export const removeCategory = (category) => ({
  type: fundRankingConstants.REMOVE_CATEGORY,
  payload: category
});

// Get User Categories
export const fetchUserCategoriesStart = () => ({
  type: fundRankingConstants.FETCH_USER_CATEGORIES_START
});

export const fetchUserCategoriesSuccess = (userCategories) => ({
  type: fundRankingConstants.FETCH_USER_CATEGORIES_SUCCESS,
  payload: userCategories
});

export const fetchUserCategoriesFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_USER_CATEGORIES_FAILURE,
  payload: errorMessage
});

export const resetUserCategories = () => ({
  type: fundRankingConstants.RESET_USER_CATEGORIES,
});

export const updateUserCategories = (payload) => ({
  type: fundRankingConstants.UPDATE_USER_CATEGORIES,
  payload
});

export const fetchRankStart = (fundId) => ({
  type: fundRankingConstants.FETCH_RANK_START,
  payload: fundId
});

export const fetchRankSuccess = (data) => ({
  type: fundRankingConstants.FETCH_RANK_SUCCESS,
  payload: data
});

export const fetchRankFailure = (errorMessage) => ({
  type: fundRankingConstants.FETCH_RANK_FAILURE,
  payload: errorMessage
});

export const saveUserCategoriesStart = (data) => ({
  type: fundRankingConstants.SAVE_USER_CATEGORIES_START,
  payload: data
});

export const saveUserCategoriesSuccess = () => ({
  type: fundRankingConstants.SAVE_USER_CATEGORIES_SUCCESS
});

export const saveUserCategoriesFailure = () => ({
  type: fundRankingConstants.SAVE_USER_CATEGORIES_FAILURE
});

// Set Queries
export const updateFundRankingQueries = (data) => ({
  type: fundRankingConstants.UPDATE_FUND_RANKING_QUERIES,
  payload: data
});

export const resetFundRankingQueries = () => ({
	type: fundRankingConstants.RESET_FUND_RANKING_QUERIES
});

export const setDefaultFundRankingQueries = (data) => ({
	type: fundRankingConstants.SET_DEFAULT_FUND_RANKING_QUERIES,
  payload: data
});

export const updateTableColumns = (columns) => ({
	type: fundRankingConstants.UPDATE_FUND_RANKING_TABLE_COLUMNS,
	payload: columns
});